import { useAppWebSocket } from 'app/utils/hooks/webSockets';
import { FC } from 'react';

export const WebSockets: FC = () => {
  useAppWebSocket();
  return null;
};
